import React, { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { useFlags, withLDProvider } from 'launchdarkly-react-client-sdk';
import { Auth0Provider, Auth0ProviderOptions } from '@auth0/auth0-react';
import Routes from './routes';
import i18next from './i18n';
import history from './utils/history';

const onRedirectCallback = (appState: any) => {
  history.push(appState && appState.returnTo ? appState.returnTo : window.location.pathname);
};

const getLDRelayURL = () => {
  let env = '';
  const smilesDomain = window.location.hostname.indexOf('smiles.com.br') > -1;
  const rx = smilesDomain ? /^(.*)\.smiles\.com\.br/g : /^(.*)\.voebiz\.com\.br/g;
  const res = rx.exec(window.location.hostname);
  if (res !== null) {
    if (res.length > 1 && res[1] && res[1].length > 3) {
      env = res[1];
    }
    env = env.replace(/portal|voebiz/g, '').replace('uat', 'hml');
  }

  if (window.location.hostname === 'localhost') {
    env = '-dev3';
  }

  return `https://ldrelay${env}.smiles.com.br`;
};

const clientSideId = '62baf3989195871574e35e6c';
const launchDarklyURL = getLDRelayURL();

function App() {
  const ldFlags = useFlags();
  const [providerConfig, setProviderConfig] = useState<Auth0ProviderOptions | undefined>(undefined);

  useEffect(() => {
    const { auth0Domain, auth0CliendId } = ldFlags;

    if (ldFlags.apiDomain) {
      setProviderConfig({
        domain: auth0Domain,
        clientId: auth0CliendId,
        audience: 'https://voebiz.api',
        redirectUri: window.location.origin,
        onRedirectCallback,
      });
    }
  }, [ldFlags]);

  if (providerConfig) {
    return (
      <Auth0Provider {...providerConfig}>
        <I18nextProvider i18n={i18next}>
          <Routes />
        </I18nextProvider>
      </Auth0Provider>
    );
  } else {
    console.log('No Auth0 Configuration.');
    return <div />;
  }
}

export default withLDProvider({
  clientSideID: clientSideId,
  user: { key: window.location.origin },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  options: {
    baseUrl: launchDarklyURL,
  },
})(App);
